<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Lead Re-allocation">
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <v-autocomplete required label="Agents *" multiple clearable chips v-model="agentsToGet" @input="filterAgents" :items="agentsList" key="id" item-value="id" item-text="fullName">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <span class="body-2 font-weight-medium"> Action </span>
            <div class="inside">
              <v-btn color="success" elevation="1" @click="getLeads()"><v-icon left>mdi-magnify</v-icon>Get leads</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <!-- <v-chip> {{ selectedRow.length }} Rows Selected </v-chip> -->

          <v-autocomplete
            clearable
            label="Filter By Spanco Status"
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="spancoFilterValue"
            :items="spancoFilterArray"
            item-text="name"
            item-value="name"
            v-on:change="spancoAssignFilter"
            placeholder="--Select--"
            style="max-width:350px;"
            required
            class="ml-auto "
          ></v-autocomplete>

          <v-autocomplete
            clearable
            label="Filter By Spanco Sub Status"
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="subStageVal"
            :items="spancoSubFilterArray"
            item-text="statusName"
            item-value="statusName"
            v-on:change="spancoAssignFilter"
            placeholder="--Select--"
            style="max-width:350px;"
            required
            class="ml-auto "
          ></v-autocomplete>

          <v-spacer></v-spacer>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
          <v-btn
            :disabled="selectedRow.length < 1"
            elevation="1"
            @click="
              () => {
                modalOk = true
              }
            "
            :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="primary"
          >
            <v-icon left>mdi-account-check</v-icon>
            Assign
          </v-btn>
          <v-btn class="ml-4" :disabled="!(leadsData.length > 0)" @click="exportToCSV()" v-if="$vuetify.breakpoint.smAndUp" color="primary" elevation="1">
            <v-icon left>mdi-download</v-icon>
            Export All
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table
          v-model="selectedRow"
          show-select
          :headers="headers"
          :items="leadsData"
          :search="search"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40, 100]
          }"
          :items-per-page="10"
        >
          <template v-slot:item.user="{ item }"> {{ item.user.firstName }} {{ item.user.lastName }} </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>

        </v-data-table>

      </v-card-component>
    </material-card>

    <v-dialog
      persistent
      v-model="modalOk"
      max-width="900"
      :active="modalOk"
      :on-cancel="
        () => {
          modalOk = false
          clearData()
        }
      "
    >
      <form @submit.prevent="saveAssignee">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Assign Agent</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(modalOk = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete required label="Assign From Agent" disabled multiple clearable chips v-model="agentsToGet" :items="agentsList" key="id" item-value="id" item-text="fullName">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete required label="Assign To Agent *" clearable v-model="agentID" :items="filteredAgents" key="id" item-value="id" item-text="fullName"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete label="Reason *" clearable v-model="reason" required :items="reasonList" item-value="name" item-text="name"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea :required="reason === 'Other'" rows="2" name="input-7-1" label="Comment" v-model.trim="comment"></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-card-actions class="justify-space-between">
                  <v-chip> {{ selectedRow.length }} Rows Selected </v-chip>
                  <v-btn color="success" type="submit">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>

    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import { mapGetters } from 'vuex'
import ExportUtility from '@/utils/exportUtility'
import _ from 'lodash'
import moment from 'moment'
export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      isLoading: false,
      leadsData: [],
      search: '',
      headers: [
        { text: 'Enquiry Code', value: 'enquiryCode' },
        { text: 'Assigned To', value: 'user' },
        { text: 'Student name', value: 'studentFullName' },
        { text: 'Gender', value: 'gender' },
        { text: 'Father name', value: 'fatherName' },
        { text: 'Class', value: 'studentClass.name' },
        { text: 'Center Name', value: 'franchiseeName' },
        { text: 'Franchisee', value: 'franchisee.companyName' },
        { text: 'SPANCO status', value: 'spancoStatus' },
        { text: 'SPANCO sub status', value: 'spancoSubStatus' },
        { text: 'Enquiry Date', value: 'dateOfEnquiry' }
      ],
      reasonList: ['Sales Rep left for the day / Long Leave(Health/Personal/ Emergency issues)', 'Leads assigned to skilled sales rep for better conversion', 'Sales Rep Attrition', 'Other'],
      selectedRow: [],
      modalOk: false,
      agentsList: [],
      agentID: '',
      reason: '',
      comment: '',
      spancoDefaultStatus: '',
      spancoDefaultStage: '',
      agentsToGet: [],
      spancoFilterArray: [],
      spancoSubFilterArray: [],
      spancoFilterValue: '',
      subStageVal: '',
      dataStore: [],
      filteredAgents: []
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onAcademicYearChange()
    }
  },

  async created () {
    this.spancoDefaultStatus = CONSTANTS.SPANCOSTATUS.DEFAULT
    this.spancoDefaultStage = CONSTANTS.SPANCOSTATUS.DEFAULTSTAGE
    await this.onFranchiseeChange()
    await this.getAgents()
  },
  methods: {
    filterAgents () {
      this.leadsData = []
      this.selectedRow = []
      this.filteredAgents = _.filter(this.agentsList, a => !this.agentsToGet.includes(a.id))
    },
    spancoAssignFilter () {
      this.leadsData = this.dataStore.filter(a => {
        if (this.spancoFilterValue && this.subStageVal) {
          return this.spancoFilterValue === a.spancoStatus && this.subStageVal === a.spancoSubStatus
        } else if (!this.spancoFilterValue && this.subStageVal) {
          return this.subStageVal === a.spancoSubStatus
        } else if (this.spancoFilterValue && !this.subStageVal) {
          return this.spancoFilterValue === a.spancoStatus
        } else {
          return true
        }
      })
    },
    saveAssignee: async function () {
      if (this.selectedRow.length < 1) {
        this.errMsg('Kindly select atleast one student!')
        return false
      }

      let formData = {
        enquiries: this.selectedRow,
        assignedToID: this.agentID,
        assignFrom: this.agentsToGet,
        reason: this.reason,
        comment: this.comment
      }
      try {
        this.isLoading = true
        await http.post(`${CONSTANTS.API_URL}/api/enquiry/update/assignee`, formData)
        await this.getLeads()
        this.clearData()
        this.selectedRow = []
        this.getAgents()
        this.modalOk = false
        this.okMsg('Leads assigned successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getAgents: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/enquiry/get-assignee`)
        this.agentsList = res.data
        this.agentsList = _.map(this.agentsList, a => {
          a.fullName = `${a.firstName} ${a.lastName}`
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getLeads: async function () {
      this.spancoFilterValue = ''
      this.subStageVal = ''
      if (this.agentsToGet.length < 1) {
        this.errMsg('Kindly select agents!')
        return false
      }
      try {
        this.isLoading = true
        let res = await http.post(`${CONSTANTS.API_URL}/api/enquiry/get/reallocation-leads`, {
          assignedTo: this.agentsToGet,
          academicYearID: this.academicYearID
        })
        this.leadsData = res.data
        this.leadsData = _.map(this.leadsData, a => {
          a.studentFullName = a.studentFirstName ? a.studentFirstName : '' + a.studentMiddleName ? a.studentMiddleName : '' + a.studentLastName ? a.studentLastName : ''
          a.dateOfEnquiry = a.dateOfEnquiry ? moment(a.dateOfEnquiry).format('DD-MM-YYYY') : ''
          a.franchiseeName = a.franchiseeName || '-'
          a.gender = a.gender || '-'
          a.spancoSubStatus = a.spancoStatus ? a.spancoStatus : this.spancoDefaultStatus
          a.spancoStatus = a.spancoStatus ? a.enquiryStage ? `${a.spancoStatus} - ${a.enquiryStage.name}` : a.spancoStatus : `${this.spancoDefaultStatus} - ${this.spancoDefaultStage}`

          if (a.studentClass) {
            a.studentClass.name = a.studentClass ? a.studentClass.name : '-'
          } else {
            a.studentClass = { name: '-' }
          }
          if (a.franchisee) {
            a.franchisee.companyName = a.franchisee ? a.franchisee.companyName : '-'
          } else {
            a.franchisee = { companyName: '-' }
          }
          return a
        })
        this.spancoFilterArray = _.uniq(_.map(this.leadsData, a => a.spancoStatus))
        this.spancoSubFilterArray = _.uniq(_.map(this.leadsData, a => a.spancoSubStatus))
        this.dataStore = this.leadsData
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    onAcademicYearChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      if (this.agentsToGet.length >= 1) {
        this.getLeads()
      }
    },
    exportToCSV () {
      const csvData = []
      this.leadsData.forEach((t, index) => {
        csvData.push({
          SRNo: index + 1,
          EnquiryCode: t.enquiryCode,
          StudentName: `${t.studentFirstName} ${t.studentLastName ? t.studentLastName : ''}`,
          Gender: t.gender,
          FatherName: t.fatherName,
          FatherEmail: t.fatherEmailID,
          OptingClass: t.studentClass.name,
          FranchiseeName: t.franchiseeName ? t.franchiseeName : '',
          SpancoStatus: t.spancoStatus,
          DateOfEnquiry: t.dateOfEnquiry
        })
      })

      ExportUtility.convertToCsv(csvData, 'FreshLeads')
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    clearData () {
      this.agentID = ''
      this.reason = ''
      this.comment = ''
    }
  }
}
</script>

<style></style>
